import { AxiosInstance } from 'axios';
import { IDrugsClient, createDrugsClient } from './Drugs';
import { createEvidenceClient, IEvidenceClient } from './Evidence';
import { IReportsClient, createReportsClient } from './Reports/reports';
import { IAuthClient, createAuthClient } from './Auth';
import { createNotificationsClient, INotificationsClient } from './Notifications';
import { createMaintenanceClient, IMaintenanceClient } from './Maintenance';
import { createCommentsClient, ICommentsClient } from './Comments';

export interface IServicesSdk {
  drugs: IDrugsClient;
  evidence: IEvidenceClient;
  reports: IReportsClient;
  auth: IAuthClient;
  notifications: INotificationsClient;
  maintenance: IMaintenanceClient;
  comments: ICommentsClient;
}

export function createServicesSdk(
  instance: AxiosInstance,
  authInstance: AxiosInstance,
  notificationsInstance: AxiosInstance,
): IServicesSdk {
  return {
    drugs: createDrugsClient(instance),
    evidence: createEvidenceClient(instance),
    reports: createReportsClient(instance),
    auth: createAuthClient(authInstance),
    notifications: createNotificationsClient(notificationsInstance),
    maintenance: createMaintenanceClient(instance),
    comments: createCommentsClient(instance),
  };
}
